export const PROJECT_CLASSIFIER = {
    'График работы': 'schedule',
    'Тип занятости': 'worktype',
    'Стаж': 'typeofexperience',
    'Место работы': 'workplace',
    'Образование': 'education_type'
};
